import { Administrator } from '@favid-inc/api';
import { Action, Filter } from 'core/generic';
import React from 'react';
import { Loading } from 'utils';
import { CreateAdmin, ListAdmins } from '../';
import { fetchAdmins, reducer } from './controller';

export interface State {
  list: Administrator[];
  isLoading: boolean;
  total: number;
  filter: Filter;
}

const initialState: State = {
  list: [],
  total: 0,
  isLoading: true,
  filter: {
    itensPerPage: 20,
    page: 0,
  },
};

class ClaimAdminComponent extends React.Component {
  state = initialState;

  componentDidMount() {
    fetchAdmins(this.state.filter, this.dispatch);
  }

  dispatch = (action: Action) => {
    this.setState(() => reducer(this.state, action));
  };

  render() {
    const { isLoading, list } = this.state;

    if (isLoading) {
      return <Loading />;
    }

    return (
      <div>
        <div className='ui segment'>
          <CreateAdmin list={list} dispatch={this.dispatch} />
        </div>
        <ListAdmins list={list} dispatch={this.dispatch} />
      </div>
    );
  }
}

export const ClaimAdmin = ClaimAdminComponent;
